import React from "react";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { Hooks, Context, Cookie, Request } from "@xt/xtbase";
import AppCookie from "utils/cookie";
import LocalesMap from "locales/map";
import styles from "./index.module.scss";

const { useTranslation } = Hooks;
const { XtContext } = Context;
const { setHeader } = Request;

const CHECK_SVG = (
  <svg className={styles["settings-option-check"]} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// 使用项目 locales/map，与 Nav 一致（含与 web-index 对齐的 zh-CN 等）
const langAry: Array<{ key: string; name: string; lab: string }> = LocalesMap;

const localeToLangKey = (locale: string | undefined): string | undefined =>
  !locale || locale === "default" ? undefined : locale === "zh-CN" ? "cn" : locale === "zh-HK" ? "hk" : locale;

const getLangKeyFromPathname = (): string | undefined => {
  if (typeof window === "undefined") return undefined;
  const first = (window.location.pathname || "").split("/").filter(Boolean)[0];
  if (!first) return undefined;
  const found = LocalesMap.find((item: { key: string; name: string }) => item.key === first || item.name === first);
  return found ? (found as { key: string }).key : undefined;
};

const SettingLanguage: React.FC = () => {
  const t = useTranslation();
  const router = useRouter();
  const [appState, appDispatch] = React.useContext(XtContext);
  const [pathnameLang, setPathnameLang] = React.useState<string | undefined>(undefined);
  React.useEffect(() => {
    setPathnameLang(getLangKeyFromPathname());
  }, []);
  const currentLang =
    (typeof window !== "undefined" ? Cookie.get("lang") : null) ??
    appState?.lang ??
    localeToLangKey(router.locale) ??
    pathnameLang ??
    "en";

  const handleSelect = (obj: { key: string; name: string; lab: string }) => {
    if (obj.key === currentLang) return;
    Cookie.set("lang", obj.key);
    AppCookie.set("langManual", "1");
    setHeader({ lang: obj.key });
    appDispatch?.({ payload: { lang: obj.key } });
    // 选择后跳转到设置页（用 replace 避免历史栈中保留设置语言页，返回时直接回 overview）
    router.replace("/accounts/user/setting", "/accounts/user/setting", { locale: obj.name });
  };

  return (
    <div className={styles["settings-select-page"]}>
      <div className={styles["settings-option-list"]}>
        {langAry.map((item) => (
          <div
            key={item.key}
            role="button"
            tabIndex={0}
            className={styles["settings-option-item"]}
            onClick={() => handleSelect(item)}
            onKeyDown={(e) => e.key === "Enter" && handleSelect(item)}
          >
            <span className={styles["settings-option-label"]}>{item.lab}</span>
            {currentLang === item.key ? CHECK_SVG : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default observer(SettingLanguage);
